export function safeNextPath(value: string | null | undefined) {
  if (!value || !value.startsWith("/") || value.startsWith("//") || value.startsWith("/api/")) return "/dashboard";
  return value;
}

/** Stepper path for finishing facility onboarding (step 5: contacts & banks, both optional). */
export const SIGNUP_SETUP_PATH = "/sign-up/setup";

/** Facility details page - the first backend page a fully onboarded admin sees. */
export const FACILITY_DETAILS_PATH = "/dashboard/management/facility";

type OnboardingStatusLike = {
  hasPendingOnboarding: boolean;
  resumePath: string | null;
} | null;

/**
 * Post-login destination honoring the onboarding gate: when the backend
 * reports a facility still on the stepper, the admin stays on
 * /sign-up/verify → /sign-up/setup until Done instead of landing on the
 * dashboard. Never throws - falls back to `nextPath` when the backend
 * does not answer (e.g. pre-migrate), so login keeps working.
 */
export async function resolvePostLoginPath(
  loadStatus: () => Promise<OnboardingStatusLike>,
  nextPath: string,
): Promise<string> {
  try {
    const status = await loadStatus();
    if (status?.hasPendingOnboarding) return status.resumePath || SIGNUP_SETUP_PATH;
  } catch {
    /* fall through to the requested destination */
  }
  return nextPath;
}
